<template>
    <el-select :value="value" class="select" filterable clearable remote :remote-method="searchCustomers" :placeholder="$t('shared.pleaseSelectCustomer')" :loading="loading" @change="selectCustomer($event)">
        <el-option v-for="item in customers" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
</template>

<script>
    import api from "./api";
    import { EventBus } from "@/app/event-bus.js";
    export default {
        name: "customer-selector",
        props: ["value", "customerName"],
        watch: {
            customerName(newValue) {
                console.info(newValue)
                if (newValue) {
                    this.searchCustomers(newValue);
                }
            }
        },
        data() {
            return {
                loading: false,
                customers: []
            };
        },
        methods: {
            searchCustomers(term) {
                var self = this;
                self.loading = true;
                api.getCustomers(term).then(function (response) {
                    self.loading = false;
                    self.customers = response.data;
                });
            },
            selectCustomer(event) {
                if (event != "" && this.$isAdmin) {
                    api.getNotifications(event).then(response => {
                        if (response.data.length > 0) {
                            this.$alert(
                                response.data
                                    .map(x => {
                                        return x.message;
                                    })
                                    .join("<br/> <hr>"),
                                "",
                                {
                                    confirmButtonText: this.$t('common.OK'),
                                    callback: action => { },
                                    dangerouslyUseHTMLString: true
                                }
                            );
                        }
                    });
                }
                this.$emit("input", event);
            },
            searchCustomersById(id, callback) {
                var self = this;
                self.loading = true;
                api.getCustomersById(id).then(function (response) {
                    self.loading = false;
                    self.customers = response.data;

                    if (callback) {
                        callback();
                    }
                });
            },
            getCustomers() {
                return this.customers;
            }
        },
        created() {
            this.searchCustomers("");
        }
    };
</script>

<style scoped>
    .select {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// ClientApp/app/shared/components/customerselector/CustomerSelector.vue